<template>
	<div class="tab-body">
		<div class="header-body">
			<el-row>
				<el-col :span="18">
					<el-card class="box-card">
						<el-form ref="form" :model="searchParams" label-width="80px">
							<el-row>
								<el-col :span="12">
									<el-form-item label="产品">
										<el-select v-model="searchParams.proId" clearable
											@change="chgPro" placeholder="请选择">
											<el-option v-for="item in productList" :key="item.id"
												:label="item.name" :value="item.id">
											</el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="Sprint">
										<el-select v-model="searchParams.sprintId"
											@change="chgSprint" clearable placeholder="请选择">
											<el-option v-for="item in this.sprintData"
												:key="item.id" :label="item.name"
												:value="item.id">
											</el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>
							<hr />

							<el-row class="boardbutton" :gutter="10">
								<el-col :span="2">
									<el-card class="vertical-text">
										进行中
									</el-card>
								</el-col>
								<el-col :span="6">
									<el-card class="el-card-box" type="primary"> 周期 {{
					HeadList.bgntm }} - {{
					HeadList.endtm }}
									</el-card></el-col>
								<el-col :span="6">
									<el-card class="el-card-box" type="primary">进行中的Sprint数量：{{
					HeadList.sprintIng
				}} / {{ HeadList.sprintAll }}</el-card>
								</el-col>

								<el-col :span="8">
									<el-card class="el-card-box" type="primary">团队：{{
					HeadList.teamName }}
									</el-card></el-col>

								<el-col :span="4">
									<el-card class="el-card-box" type="primary">会议数量：{{
					HeadList.meetingNum }}
									</el-card></el-col>
								<el-col :span="4">
									<el-card class="el-card-box" type="primary">审视数量：{{
					HeadList.surveyNum }}</el-card>
								</el-col>
								<el-col :span="4">
									<el-card class="el-card-box" type="primary">bugs数量：{{
					HeadList.surveyBugNum ? item.surveyBugNum : 0 }}
									</el-card></el-col>

								<el-col :span="8">
									<el-card class="el-card-box" type="primary">可用工时：{{
					(HeadList.sprintHourDiffer / 8).toFixed(1) }} / {{
					HeadList.hopegs }}
										人日</el-card></el-col>
							</el-row>
						</el-form>
					</el-card>
					<el-card>
						<el-tabs v-model="activeName">
							<el-tab-pane label="待办" name="first">
								<template slot-scope="scope">
									<el-row>
										<el-col :span="6"
											v-for="(item, index) in ListData.sprintBacklog"
											@click="example(index)" :key="item.id">

											<el-card class="box-card"
												style="width: 330px; height: 180px; margin-bottom: 20px;"
												:class="changecolor(item.states)">
												<div slot="header" class="clearfix">
													<span>{{ item.name }}</span>
												</div>
												<div>团队成员：{{ item.tmName }}</div>
												<div style="margin-top: 5px">
													<!-- <el-tag type="success">{{ item.states }}</el-tag> -->
													<el-tag v-if="item.states == '未开始'"
														type="info">{{ item.states
														}}</el-tag>
													<el-tag v-else-if="item.states == '进行中'"
														type="warning">{{
					item.states }}</el-tag>
													<el-tag v-else type="success">{{
					item.states }}</el-tag>
												</div>
												<div>
													完成进度：{{ item.wchours > 0 ? ((item.wchours
					/ item.hopegs) *
					100).toFixed(0)
					: 0 }}%
												</div>
												<div>计划周期： {{ item.pbgntm }} ~ {{ item.pendtm }}
												</div>
											</el-card>
										</el-col>
									</el-row>
								</template>


							</el-tab-pane>


							<el-tab-pane label="审视" name="second">
								<template slot-scope="scope">
									<el-row>
										<el-col :span="6" v-for="item in ListData.survey"
											:key="item.id">
											<el-card class="box-card"
												style="width: 250px; height: 250px"
												:class="changecolor1(item.state)">
												<div slot="header" class="clearfix">
													<span>{{ item.modeName }}</span>
												</div>
												<div>团队：{{ item.teamName }}</div>
												<div style="margin-top: 5px">
													<el-tag type="success">{{
					item.state == 1
						? "未开始"
						: item.state == 2
							? "进行中"
							: item.state == 3
								? "未完成"
								: item.state == 4
									? "已完成"
									: item.state == 5
										? "已关闭"
										: item.state == 6
											? "已挂起"
											: "已延期"
				}}</el-tag>
												</div>
												<div>
													bug数量：<span v-if="item.bugcnt">{{
					item.bugcnt
				}}</span>
													<span v-else>0</span>
												</div>
												<div>
													计划周期：{{ item.pbgntm }} ~ {{ item.pendtm }}
												</div>
											</el-card>
										</el-col>
									</el-row>
								</template>
							</el-tab-pane>
							<el-tab-pane label="会议" name="third">
								<template slot-scope="scope">
									<el-row>
										<el-col :span="6" v-for="item in ListData.meeting"
											:key="item.id">
											<el-card class="box-card"
												style="width: 250px; height: 300px"
												:class="changecolor1(item.state)">
												<div slot="header" class="clearfix">
													<span>{{ item.name }}</span>
												</div>
												<div>
													会议类型：{{
					item.type == 1
						? "站会"
						: item.type == 2
							? "计划会议"
							: item.type == 3
								? "审视会议"
								: item.type == 4
									? "回顾会议"
									: "评审会议"
				}}
												</div>
												<div style="margin-top: 5px">
													会议时间：{{ item.meettm }}
												</div>
												<div>
													执行状态：{{
					item.state == 1
						? "未开始"
						: item.state == 2
							? "进行中"
							: item.state == 3
								? "未完成"
								: item.state == 4
									? "已完成"
									: item.state == 5
										? "已关闭"
										: item.state == 6
											? "已挂起"
											: "已延期"
				}}
												</div>
												<div>主持人：{{ item.host }}</div>
												<div>参会人：{{ item.participant }}</div>
											</el-card>
										</el-col>
									</el-row>
								</template>
							</el-tab-pane>
						</el-tabs>
					</el-card>
				</el-col>
				<el-col :span="6">
					<el-row>
						<el-card class="box-card">
							<el-row style="font-weight: bold">
								<el-row>
									<div id="myChart" :style="{
					width: '100%',
					height: '299px',
					backgroundColor: '#fff',
				}"></div>
								</el-row>
							</el-row>
						</el-card>
					</el-row>

					<el-row>

						<el-card class="box-card"
							style="font-size: 16px; font-weight: bold; text-align: center">
							动态
						</el-card>

						<el-row style="max-height: 340px; overflow-y: auto;">
							<div class="infinite-list-wrapper" v-infinite-scroll="loadTrendsPage">
								<el-card class="box-card" v-for="item in trendsData" :key="item.id">
									<el-row style="font-size: 14px; ">

										<!-- {{ item.crtm }}{{ item.dbColumn_crer }} {{ item.operate }} {{ item.problemSolving }} -->
										[{{ item.crtm }}]{{ item.dbColumn_crer }} {{ item.operate }}
										{{ item.problemSolving }}
									</el-row>
								</el-card>
							</div>
						</el-row>


					</el-row>

				</el-col>
			</el-row>
		</div>


	</div>

</template>

<script>
import api from "@/api/sprint/sprintBoard/sprintBoard.js";
import apiProductBoard from "@/api/product/productBoard/productBoard.js";
import productApi from "@/api/product/product/product.js";
import apiSur from "@/api/sprint/survey/survey.js";
import apiMeet from "@/api/sprint/meeting/meeting.js";
import apiSBL from "@/api/sprint/sprintBacklog/sprintBacklog.js";
import {
	log
} from "console";

export default {
	components: {
		api,
		apiProduct: productApi,
		apiSBL,
		apiSur,
		apiMeet,
		log,
	},
	data() {
		return {

			loading: false,
			activeName: "first",
			searchParams: {}, //装载产品id和待办id
			ListData: [], //list()返回的数据
			HeadList: [], //装载头部数据
			productList: [], //装载产品的数据
			sprintData: [], //装载sprint的数据
			spriCntId: "",
			sprintListData: [], //装载待办的数据
			num: 0,
			ShenshiBugNum: 0,

			ShenShilistData: [], //装载审视的数据
			MeetlistData: [], //装载会议的数据

			trendsData: [], //动态表数据
			pids: [], //父pid列表
			page: new this.$constant.pageObj(),
		};
	},
	methods: {

		//更改背景颜色
		changecolor(valu) {
			if (valu == "未开始") {
				return 'box-card-a1'
			} else if (valu == "进行中") {
				return 'box-card-a2'
			} else {
				return 'box-card-a3'
			}
		},

		changecolor1(valu) {
			if (valu == '1') {
				return 'box-card-a1'
			} else if (valu == '2') {
				return 'box-card-a2'
			} else if (valu == '3') {
				return 'box-card-a3'
			} else if (valu == '4') {
				return 'box-card-a4'
			} else if (valu == '5') {
				return 'box-card-a5'
			} else if (valu == '6') {
				return 'box-card-a6'
			} else {
				return 'box-card-a7'
			}
		},

		//页面初始化,获取产品数据，从浏览器获取存储的产品和sprint数据， 主要是初始化顶部搜索框条件
		init() {
			//去本地缓存加载当前未结束的productList

			this.productList = this.$caches.products.get();
			//如果没有
			if (this.productList) {
				//初始化搜索框内容
				this.searchParams.proId = this.$caches.pid.get();

				if (!this.searchParams.proId) {
					this.searchParams.proId = this.productList[0].id;
					this.$caches.pid.set(this.searchParams.proId);
				}

				//查询该产品的sprint数据并存入 sprintData
				apiSBL.getSBLByProId({
					proId: this.searchParams.proId
				}, (response) => {
					this.sprintData = response.data;

					if (this.sprintData.length > 0) {
						//console.log("初始化到这里!!!!!!!");

						this.sprintId = this.$caches.sprintId.get();
						//console.log("初始化到这里!!!!!!!", this.sprintId);
						if (!this.sprintId) {
							this.sprintId = this.sprintData[0].id;
						}
						this.searchParams.sprintId = this.sprintId;
						this.$caches.sprintId.set(this.sprintId)
					}

					this.chgPro(this.searchParams.proId);
				})
			} else {

				//获取产品数据并存入productData
				productApi.list4Select({}, response => {
					this.productList = response.data;
					//初始化搜索框内容
					this.searchParams.proId = this.productList[0].id;

					this.$caches.products.set(this.productList);
					this.$caches.pid.set(this.searchParams.proId);

					//查询该产品的sprint数据并存入 sprintData
					apiSBL.getSBLByProId({
						proId: this.searchParams.proId
					}, (response) => {
						this.sprintData = response.data;

						if (this.sprintData.length > 0) {
							//console.log("初始化到这里!!!!!!!");

							this.sprintId = this.$caches.sprintId.get();
							//console.log("初始化到这里!!!!!!!", this.sprintId);
							if (!this.sprintId) {
								this.sprintId = this.sprintData[0].id;
							}
							this.searchParams.sprintId = this.sprintId;
							this.$caches.sprintId.set(this.sprintId)
						}

						this.chgPro(this.searchParams.proId);
					})
				})

			}





		},

		//获取数据
		list() {
			this.trendsData = []
			this.myChart = this.$echarts.init(document.getElementById("myChart"));
			// 绘制图表
			var option = {
				title: {
					text: "燃烬图",
				},
				tooltip: {
					trigger: "axis",
				},
				//头部信息
				legend: {
					data: ["工时资源", "完成", "消耗"],
				},
				grid: {
					left: "3%",
					right: "4%",
					bottom: "3%",
					containLabel: true,
				},
				toolbox: {
					feature: {
						myFull: {
							show: true,
							title: "全屏",
							icon: "path://M796.1 262.5S874.4 447.8 650.6 659c0 0 117.4-21.8 168.3-155.6s-22.8-240.9-22.8-240.9zM803.2 822.8s-10.4 90.7-101.4 107.3c0 0 11.2 45.7 85.8-7.8s15.6-99.5 15.6-99.5zM841.5 879.7c-1.2-6.8-2.7-16-91.7-168.4-14.9-25.4-29.7-50.7-42.8-72.9-6.2 4.9-13.1 9.1-20.3 13 51.2 86.6 129 219.8 131.1 232.3 3.2 18.5-76 52.1-92.6 52.1h-0.6c-10.7-0.6-70.6-155.9-105.3-248.4-7.9 1.1-15.2 4.9-23.1 7 10.2 27.1 22.5 59.6 35.1 92 17.9 46 32.9 82.8 44.4 109.3 7.1 16.3 12.9 28.6 17.6 37.5 5.7 10.8 13.6 25.7 29.9 26.6 0.6 0 1.2 0.1 1.9 0.1 21.7 0 87.3-27.7 107.2-51.3 9.8-11.4 10.4-22 9.2-28.9zM496.4 88.1c52.9 0 106.5 12.9 154.8 40 98 55 176.8 158.1 175 274.2-0.2 10.4-1 20.7-2.4 31-21.7 154.3-178 264.1-330.5 264.1-32.2 0-64.2-4.9-94.8-15.3-140.3-47.8-220.7-218-196.3-359.4 12.9-74.4 52.3-133 105.5-173 53.3-40.1 120.4-61.6 188.7-61.6m0-24.1c-74.1 0-146.3 23.6-203.2 66.4-61.8 46.5-101.5 111.6-114.8 188.2-12.9 74.4 1.2 158.3 38.7 230.1 39.8 76.2 101.4 131.7 173.5 156.3 32.3 11 66.8 16.6 102.5 16.6 80 0 163.4-28.9 228.9-79.2 69.7-53.6 114.3-126.6 125.4-205.7 1.6-11.2 2.5-22.6 2.6-33.9 0.9-59.6-17.8-119.8-54.2-173.8-33.3-49.4-79.3-91.5-133.1-121.8C612.7 78.9 555.1 64 496.4 64zM760.9 593.4c-2.1 0-4.1-0.8-5.7-2.4l-14-14c-3.1-3.1-3.1-8.2 0-11.4 3.1-3.1 8.2-3.1 11.4 0l14.1 14.1c3.1 3.1 3.1 8.2 0 11.4-1.6 1.5-3.7 2.3-5.8 2.3zM741.1 621.9c-2.1 0-4.1-0.8-5.7-2.4l-18.2-18.2c-3.1-3.1-3.1-8.2 0-11.4 3.1-3.1 8.2-3.1 11.4 0l18.2 18.2c3.1 3.1 3.1 8.2 0 11.4-1.6 1.6-3.6 2.4-5.7 2.4zM821.1 900.7c-2.1 0-4.1-0.8-5.7-2.4l-22.1-22.1c-3.1-3.1-3.1-8.2 0-11.4s8.2-3.1 11.4 0l22.1 22.1c3.1 3.1 3.1 8.2 0 11.4-1.6 1.6-3.7 2.4-5.7 2.4zM803.2 924.9c-2.1 0-4.1-0.8-5.7-2.4l-20.8-20.8c-3.1-3.1-3.1-8.2 0-11.4 3.1-3.1 8.2-3.1 11.4 0l20.8 20.8c3.1 3.1 3.1 8.2 0 11.4-1.6 1.6-3.7 2.4-5.7 2.4zM777 938.6c-2.1 0-4.1-0.8-5.7-2.4L755.1 920c-3.1-3.1-3.1-8.2 0-11.4 3.1-3.1 8.2-3.1 11.4 0l16.2 16.2c3.1 3.1 3.1 8.2 0 11.4-1.6 1.7-3.6 2.4-5.7 2.4zM750.1 952.8c-2.1 0-4.1-0.8-5.7-2.4L730 936c-3.1-3.1-3.1-8.2 0-11.4 3.1-3.1 8.2-3.1 11.4 0l14.4 14.4c3.1 3.1 3.1 8.2 0 11.4-1.6 1.6-3.7 2.4-5.7 2.4zM782.8 564.8c-2.1 0-4.1-0.8-5.7-2.4l-16.8-16.8c-3.1-3.1-3.1-8.2 0-11.4 3.1-3.1 8.2-3.1 11.4 0l16.8 16.8c3.1 3.1 3.1 8.2 0 11.4-1.6 1.6-3.6 2.4-5.7 2.4zM806.5 536.8c-2.1 0-4.1-0.8-5.7-2.4L780 513.6c-3.1-3.1-3.1-8.2 0-11.4 3.1-3.1 8.2-3.1 11.4 0l20.8 20.8c3.1 3.1 3.1 8.2 0 11.4-1.6 1.6-3.6 2.4-5.7 2.4zM820.5 498.3c-2.1 0-4.1-0.8-5.7-2.4L797 478.1c-3.1-3.1-3.1-8.2 0-11.4 3.1-3.1 8.2-3.1 11.4 0l17.8 17.8c3.1 3.1 3.1 8.2 0 11.4-1.6 1.7-3.6 2.4-5.7 2.4zM834.6 462.8c-2.1 0-4.1-0.8-5.7-2.4L808 439.5c-3.1-3.1-3.1-8.2 0-11.4 3.1-3.1 8.2-3.1 11.4 0l20.9 20.9c3.1 3.1 3.1 8.2 0 11.4-1.6 1.6-3.7 2.4-5.7 2.4zM840.1 417.2c-2.1 0-4.1-0.8-5.7-2.4L812.5 393c-3.1-3.1-3.1-8.2 0-11.4 3.1-3.1 8.2-3.1 11.4 0l21.9 21.9c3.1 3.1 3.1 8.2 0 11.4-1.6 1.5-3.7 2.3-5.7 2.3zM500.2 163.6c39.8 0 80.1 9.7 116.5 30.1 73.7 41.4 133.1 119 131.7 206.4-0.1 7.8-0.7 15.6-1.8 23.3-16.3 116.2-134 198.8-248.7 198.8-24.2 0-48.3-3.7-71.3-11.5-105.6-36-166.1-164.1-147.7-270.5 9.7-56 39.4-100.1 79.4-130.2 40-30.3 90.5-46.4 141.9-46.4m0-24.1c-57.1 0-112.6 18.2-156.5 51.2-47.8 35.9-78.4 86.2-88.7 145.4-9.9 57.3 0.9 121.8 29.7 177 30.7 58.7 78.3 101.5 134 120.5 24.9 8.5 51.6 12.8 79.1 12.8 61.5 0 125.6-22.2 175.9-60.8 53.7-41.3 88.1-97.6 96.6-158.7 1.2-8.7 1.9-17.5 2-26.3 0.7-46.1-13.7-92.5-41.8-134.3-25.6-38-60.9-70.3-102.2-93.5-38.5-21.9-82.9-33.3-128.1-33.3zM409.1 235.8s-57.7 44.4-63.3 88.8M345.8 336.7c-0.5 0-1 0-1.5-0.1-6.6-0.8-11.3-6.9-10.4-13.5 6.1-48.8 65.3-94.9 67.9-96.8 5.3-4.1 12.8-3.1 16.9 2.2s3.1 12.8-2.2 16.9c-14.9 11.5-54.6 48.5-58.7 80.7-0.8 6.1-6 10.6-12 10.6zM333.4 412.1c-0.4 0-0.8 0-1.2-0.1-6.6-0.7-11.4-6.6-10.8-13.2l2.6-25.6c0.7-6.6 6.6-11.4 13.2-10.8 6.6 0.7 11.4 6.6 10.8 13.2l-2.6 25.6c-0.7 6.3-5.9 10.9-12 10.9z",
							onclick: (e) => {
								const element = document.getElementById("myChart");
								// 一些浏览器的兼容性
								if (element.requestFullScreen) {
									// HTML W3C 提议
									element.requestFullScreen();
								} else if (element.msRequestFullscreen) {
									// IE11
									element.msRequestFullScreen();
								} else if (element.webkitRequestFullScreen) {
									// Webkit (works in Safari5.1 and Chrome 15)
									element.webkitRequestFullScreen();
								} else if (element.mozRequestFullScreen) {
									// Firefox (works in nightly)
									element.mozRequestFullScreen();
								}

								// 退出全屏
								if (element.requestFullScreen) {
									document.exitFullscreen();
								} else if (element.msRequestFullScreen) {
									document.msExitFullscreen();
								} else if (element.webkitRequestFullScreen) {
									document.webkitCancelFullScreen();
								} else if (element.mozRequestFullScreen) {
									document.mozCancelFullScreen();
								}
							},
						},
					},
				},
				//x轴一行最多显示21个
				xAxis: {
					type: "category",
					boundaryGap: false,
					data: null,
					axisLabel: {
						formatter: function (value) {
							return value.substr(5);
						},
						rotate: -90, // 旋转标签，保持纵向显示
					},
				},
				yAxis: {
					type: "value",
				},
				series: [{
					name: "工时资源",
					type: "line",
				},
				{
					name: "完成",
					type: "line",
				}, {
					name: "消耗",
					type: "line",
				}
				],
			};


			//获取卡片数据
			api.list({
				id: this.sprintId
			}, (res) => {

				if (res.data) {
					//获取卡片数据
					api.headList({
						id: this.sprintId
					}, (res2) => {
						this.HeadList = res2.data;
						//console.log("三生三世 ", this.HeadList);
					});


					this.ListData = res.data;

					if (this.ListData.burnUp) {
						option.xAxis.data = this.ListData.burnUp.xAxisData;
						option.series[0].data = this.ListData.burnUp.seriesData1;
						option.series[1].data = this.ListData.burnUp.seriesData2;
						option.series[2].data = this.ListData.burnUp.seriesData3;
						this.myChart = this.$echarts.init(
							document.getElementById("myChart")
						);
						//防止越界，重绘canvas，解决掉屏幕缩小，图表不会随之适应的缩小的方法
						window.onresize = this.myChart.resize;
						//设置option
						this.myChart.setOption(option);
					}
				} else {
					this.ListData = {
						header: {}
					};
				}

			}, err => {
				this.$utils.msg.warning("没有数据")
			});

			//下拉框产品名字
			// let params = {
			// 	id: localStorage.getItem("sprintId")
			// };
			// api.chartlist(params, (response) => {

			// 	console.log(response);
			// 	//尝试取得前端存储的pid
			// 	let pid = this.$caches.pid.get();
			// 	if (!pid) {
			// 		//默认第一个
			// 		if (this.options[0]) {
			// 			pid = this.options[0].value;
			// 		}
			// 	}

			// });

			// //获取审视数据
			apiSur.list({ sprintId: this.searchParams.sprintId }, response => {
				this.ShenShilistData = response.data.records;
				this.ShenshiBugNum = 0;
				for (let index = 0; index < this.ShenShilistData.length; index++) {
					if (this.ShenShilistData[index].bugcnt) {
						//累加bug数量
						this.ShenshiBugNum += this.ShenShilistData[index].bugcnt;
					}

				}
			});

			//获取会议数据
			let params2 = this.$utils.merger(this.searchParams);
			apiMeet.list(params2, response => {
				this.MeetlistData = response.data.records;
			});

			this.getTrendsList()
		},

		//产品改变
		chgPro(val) {
			this.num = 0;
			//下拉时改变产品缓存pid
			this.$caches.pid.set(val);
			let proId = val;
			this.selectProd = val;
			this.searchParams.proId = val;
			//改变产品 查询该产品下的sprint数据
			apiSBL.getSBLByProId({
				proId
			}, (response) => {
				this.sprintData = response.data;


				if (this.sprintData.length !== 0) {
					//默认选中第一个sprintid
					let flag = 0;
					for (let i = 0; i < this.sprintData.length; i++) {
						if (this.sprintData[i].id == this.$caches.sprintId.get()) {
							flag = 1;
						}
					}
					//console.log("flag==", flag);

					if (flag == 1) {
						this.searchParams.sprintId = this.$caches.sprintId.get();
					} else {
						this.searchParams.sprintId = this.sprintData[0].id;
						this.sprintId = this.sprintData[0].id;
						//向浏览器存入sprintId

					}
					localStorage.setItem("sprintId", this.sprintData[0].id);
					this.list();


				} else {
					this.list();

					//如果该产品没有sprint则移除之前所有存过的sprintid
					this.$caches.sprintId.remove();
					//localStorage.removeItem("sprintId");

					delete this.searchParams.sprintId
					this.sprintId = "";
				}
			});

		},
		//spint改变
		chgSprint(val) {
			this.num = 0;
			this.searchParams.sprintId = val;
			this.sprintId = val;
			//将改变的sprintID存入浏览器
			localStorage.setItem("sprintId", val);

			this.list();
		},
		example(index) {
		//	console.log("sssadw ", index);
		},

		//获取燃尽图动态信息
		getTrendsList() {

			let params = this.$utils.merger({ id: this.sprintId }, this.page);

			api.tendlist(params, (response) => {

				this.page.current = response.data.current
				this.page.pages = response.data.pages
				//console.log("this.page", this.page)
				this.trendsData = this.trendsData.concat(response.data.records);
				this.loading = false

			});
		},


		loadTrendsPage() {

			if (this.page.current < this.page.pages) {
				this.page.current++;
				this.getTrendsList()
			}

		},
	},
	mounted() {
		this.init();
	},







};
</script>
<style>
.box-card-a1 {
	background-color: rgb(224, 174, 174);
	border-color: black;
	margin-bottom: 15px;
}

.box-card-a2 {
	background-color: rgb(208, 197, 158);
	border-color: black;
	margin-bottom: 15px;
}

.box-card-a3 {
	background-color: rgb(167, 223, 165);
	border-color: black;
	margin-bottom: 15px;
}

.box-card-a4 {
	background-color: rgb(248, 248, 248);
	border-color: black;
	margin-bottom: 15px;
}

.box-card-a5 {
	background-color: rgb(132, 154, 180);
	border-color: black;
	margin-bottom: 15px;
}

.box-card-a6 {
	background-color: rgb(84, 109, 82);
	border-color: black;
	margin-bottom: 15px;
}

.box-card-a7 {
	background-color: rgb(73, 30, 106);
	border-color: black;
	margin-bottom: 15px;
}




.boardbutton .el-col {
	margin-top: 10px;

}

.box-card {
	margin: 3px;

}

.el-card-box {
	background-color: #4b88bd;
	color: white;
}

.sprint_card {
	width: 300px;
	height: 200px;
}

.vertical-text {
	writing-mode: vertical-lr;
	border-radius: 5px;
	font-weight: 600;
	font-size: 22px;
	height: 120px;
	color: hsl(0, 0%, 100%);
	background-color: rgb(18, 74, 158);
	display: flex;
	justify-content: center;
	align-items: center;
}
</style>